import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M 19.816 16.877 L 11.286 1.742 C 11.007 1.247 10.503 1 10 1 S 8.993 1.247 8.714 1.742 L 0.184 16.877 C -0.354 17.832 0.354 19 1.47 19 H 18.53 C 19.647 19 20.354 17.832 19.816 16.877 Z M 18.932 17.799 C 18.881 17.883 18.762 18.023 18.53 18.023 H 1.47 C 1.238 18.023 1.119 17.883 1.068 17.799 S 0.949 17.546 1.061 17.348 L 9.591 2.213 C 9.707 2.008 9.897 1.977 10 1.977 S 10.293 2.008 10.409 2.213 L 18.939 17.348 C 19.051 17.546 18.982 17.716 18.932 17.799 Z M 9.5 13 L 9.045 6.539 A 0.498 0.498 0 0 1 9.541 6 H 10.458 C 10.749 6 10.979 6.249 10.954 6.539 L 10.499 13 H 9.499 Z M 11 15 C 11 15.571 10.571 16 10 16 S 9 15.571 9 15 S 9.429 14 10 14 S 11 14.429 11 15 Z',
  ],
  height: 20,
  width: 20,
});
